export type FormRef = HTMLInputElement | HTMLTextAreaElement | null;
type GetUpdatedTextWithEmoji = <T>(
  currentText: string,
  emoji: string,
  ref?: FormRef,
  restoreFocus?: boolean,
) => string;

export const getUpdatedTextWithEmoji: GetUpdatedTextWithEmoji = (
  currentText,
  emoji,
  ref,
  restoreFocus,
) => {
  const text = currentText || '';

  if (ref) {
    const start = ref.selectionStart;
    const end = ref.selectionEnd;

    if (restoreFocus) {
      setTimeout(() => {
        ref.focus();
        if (start !== null) {
          ref.selectionStart = start + emoji.length;
          ref.selectionEnd = start + emoji.length;
        }
      }, 1);
    }
    if (text && start !== null && end !== null) {
      return text.substr(0, start) + emoji + text.substr(end, text.length);
    }
  }

  return text + emoji;
};
